
import { AppFilter } from "app/models/app-filter.model";
import { Compartimento } from "app/models/compartimento.model";
import { Dispositivo } from "app/models/dispositivo.model";
import { TamanhoCompartimento } from "app/models/tamanhoCompartimento.model";
import { AppService } from "app/services/app.service";
import { BehaviorSubject, Observable } from "rxjs";

export abstract class AbDispositivo extends AppService {

  abstract mostrarButtonAdicionar: BehaviorSubject<boolean>;

  abstract carregarDispositivo(id: number);
  abstract conectarDispositivo(dispositivo: Dispositivo): Observable<any>;
  abstract testeConexaoDispositivoCaixaCorreioInteligente(config): Observable<any>;
  abstract testeConexaoDispositivoLockerPadrao(config): Observable<any>;
  abstract carregarTamanhosCompartimento(id: number);
  abstract abrirPortaCompartimentoTamanho(tamanhoCompartimento: TamanhoCompartimento): Observable<any>;
  abstract abrirPortaCompartimento(compartimento: Compartimento): Observable<any>;
  abstract buscarAcessoGPS(): Observable<any>;
  abstract getAllFabricantesControleAcessoAtivos();
  abstract getAllFabricantesVoipAtivos();
  abstract salvar(dispositivo: Dispositivo): Observable<any>;
  abstract salvarBiccateca(dispositivo: Dispositivo): Observable<any>;
  abstract salvarLocker(dispositivo: Dispositivo): Observable<any>;
  abstract desativar(id: number);
  abstract getAllDispositivos(filter: AppFilter): Observable<any>;
  abstract getAllDispositivosVoip(filter: AppFilter): Observable<any>;
  abstract getAllDispositivosLocker(filter: AppFilter): Observable<any>;
  abstract getAllDispositivosLockerGenerico(filter: AppFilter): Observable<any>;
  abstract testarConexao(dispositivo: Dispositivo);
  abstract getDispositivosLockerSemCaixaCorreioInteligente(): Observable<any>;
  abstract sincronizarSenhas(): Observable<any>;
  abstract getModeloNome(modeloNome: string);
  abstract salvarByModelo(dispositivo: any);
  abstract getDispositivosControlaAcesso();
  abstract getAllFabricantesAtivos();
  abstract getAllFabricantesControlaAcesso();
  abstract getAllFabricante(fabricanteId: number);
  abstract getAllModelosFabricanteControlaAcesso(fabricanteId: number);
  abstract getAllVoipFabricante(fabricanteId: number);
  abstract getAllDispositivosColeta(tipoColeta: any): Observable<any>;
  abstract getAllDispositivosEntrega(filter: AppFilter): Observable<any>;
  abstract salvarEntregaAutonoma(dispositivoEntregaDTO): Observable<any>;
  abstract getDispositivoEntregaById(id: number): Observable<any>;
  abstract abrirCompartimento(dispositivoEntregaDTO: any): Observable<any>;
  abstract salvarCorrespondencia(correspondenciaDTO: any): Observable<any>;
  abstract getComprovanteById(dispositivoId: number): Observable<any>;
  abstract abrirCompartimentoBoxAI(dispositivoEntregaDTO: any): Observable<any>;
  abstract atualizarDescricao(id: number, dispositivo: any): Observable<any>;
  abstract getDispositivo(id: number): Observable<any>;
  abstract getStatusEntregaAutonomaAguardando(id: number): Observable<any>;

}
